/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { schemaOrgWebPage, schemaEvent, schemaOrganization } from "./Schema.js"

function SEO({ lang, metaTags, translations, title }) {
  const hreflangData = translations.map(translation => ({
    rel: "alternate",
    hreflang: translation.langcode.value,
    href: translation.path_alias,
  }))

  const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "develop"

  const environments = {
    staging: "launch-f0490450c5cf-staging",
    develop: "launch-e7dc4271fcde-development",
    production: "launch-be034d63605e",
  };

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      link={hreflangData}
      meta={metaTags}
    >
      <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" type="text/javascript" charset="UTF-8" data-domain-script="f032affe-7e31-4034-927b-7790b34e6630" ></script>

      <script type="text/javascript">
        {`function OptanonWrapper() { }`}
      </script>


      <script src={`https://assets.adobedtm.com/6bb3f7663515/fea558f43eb7/${environments[activeEnv] || environments.production}.min.js`} async></script>
      {
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgWebPage)}
        </script>
      }

      {
        <script type="application/ld+json">
          {JSON.stringify(schemaEvent)}
        </script>
      }

      {
        <script type="application/ld+json">
          {JSON.stringify(schemaOrganization)}
        </script>
      }
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  metaTags: [],
  translations: [],
  title: "",
}

SEO.propTypes = {
  lang: PropTypes.string,
  metaTags: PropTypes.arrayOf(PropTypes.object),
  translations: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
}

export default SEO
